import { api } from '@/scripts/api';

export const LandingPageFormSubmissionService = {

    get(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = `/service/LandingPageFormSubmissions(${ id })`;

            const endpoint = api.applyODataParams(service, config);

            api.get(endpoint)
                .then(resolve)
                .catch(reject);

        });
    },

    getAll(config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/LandingPageFormSubmissions';

            const endpoint = api.applyODataParams(service, config);
           
            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        });
    },

    delete(id){
        return new Promise((resolve, reject) => {
            const service = `/api/LandingPageFormSubmissions/${id}`;

            api
                .delete(service)
                .then(resolve)
                .catch(reject);
        })
    },

    deleteAll(ids) {

        const service = '/api/LandingPageFormSubmissions';

        return new Promise((resolve, reject) => {
            api
                .delete(service, ids)
                .then(resolve)
                .catch(reject);
        });

    },

}
